var map = {
	"./Clip-path-group(1).png": 64464,
	"./Clip-path-group-(10).png": 11172,
	"./Clip-path-group-(11).png": 1140,
	"./Clip-path-group-(2).png": 9360,
	"./Clip-path-group-(3).png": 81860,
	"./Clip-path-group-(4).png": 90880,
	"./Clip-path-group-(5).png": 28799,
	"./Clip-path-group-(6).png": 49612,
	"./Clip-path-group-(7).png": 18844,
	"./Clip-path-group-(8).png": 97824,
	"./Clip-path-group-(9).png": 21176,
	"./Clip-path-group.png": 13260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48728;